/**
 * WIP on `TRADE_ROUTE`(ex `FUTURES_ROUTE):
 *  We also need to rename all the `perpetuals` references in code (file, folder, variable names)
 *  open separate PR to `rename-all` when we have enough test coverage
 */
export const TRADE_ROUTE = '/trade';
export const TRADE_SYMBOL_SEGMENT = ':symbol';
export const TRADE_SYMBOL_ROUTE = `/trade/${TRADE_SYMBOL_SEGMENT}`;

export const PORTFOLIO_ROUTE = '/portfolio';
export const STATUS_ROUTE = '/status';
export const LEADERBOARD_ROUTE = '/leaderboard';
export const POINTS_ROUTE = '/points';
export const REFERRALS_ROUTE = '/referrals';
export const REFERRAL_ROUTE = '/r';
export const REFERRAL_CODE_ROUTE = `/${REFERRAL_ROUTE}/:referralCode`;

export type TradeRouteParams = {
  symbol?: string;
};
